import React, { ReactNode } from 'react';
import { LucideIcon } from 'lucide-react';

export interface ViewOption<T extends string = string> {
  value: T;
  icon?: LucideIcon;
  content?: ReactNode;
  label?: string;
  title: string;
}

interface ViewToggleProps<T extends string = string> {
  viewMode: T;
  onViewModeChange: (mode: T) => void;
  options: ViewOption<T>[];
  iconSize?: number;
}

export function ViewToggle<T extends string = string>({
  viewMode,
  onViewModeChange,
  options,
  iconSize = 18
}: ViewToggleProps<T>) {
  return (
    <div className="flex items-center gap-2 bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
      {options.map((option) => {
        const Icon = option.icon;
        const hasLabel = !!option.label;
        return (
          <button
            key={option.value}
            onClick={() => onViewModeChange(option.value)}
            className={`${hasLabel ? 'px-3 py-1' : 'p-2'} rounded transition-colors ${
              viewMode === option.value
                ? 'bg-white dark:bg-gray-600 text-primary-600 dark:text-primary-400 shadow-sm font-medium'
                : 'text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-gray-200'
            } ${hasLabel ? 'text-sm' : ''}`}
            title={option.title}
          >
            {option.content ? (
              option.content
            ) : option.label ? (
              option.label
            ) : Icon ? (
              <Icon size={iconSize} />
            ) : null}
          </button>
        );
      })}
    </div>
  );
}
